module.exports = __webpack_public_path__ + "img/quxiao2_h5.0297590.jpg";